import { useState, useCallback, useEffect } from "react";
import { Modal, Button, Stack, Col, Row } from "react-bootstrap";
import { getData } from "../../api/informacionProyectos";
import { IInformacionProyectos } from "../../interfaces/InformacionProyectos";
import { notifyError } from "../../util/notiflixHelpers";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

type ProjectModalProps = {
  crono: string;
  subcrono: string;
  show: boolean;
  hide: () => void;
};

const ProjectModal: React.FC<ProjectModalProps> = ({
  crono,
  subcrono,
  show,
  hide,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "iniciativas.project_modal",
  });
  const [project, setProject] = useState<IInformacionProyectos>();
  const fetchData = useCallback(async () => {
    try {
      const res = await getData(crono, subcrono);
      setProject(res[0]);
    } catch (error) {
      notifyError(
        "Error al cargar la informacion del proyecto " + crono + "-" + subcrono,
        "Error",
        "Ok"
      );
      console.log("error: ", error);
    }
  }, [crono, subcrono]);

  useEffect(() => {
    if (show) {
      fetchData();
    }
  }, [show, fetchData]);

  return (
    <Modal show={show} onHide={hide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">{project?.nombreInstrumento}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-4">
            <strong>{t("codigo")}: </strong>
            {project?.codigo}/{project?.cronoICT + "-" + project?.subcronoICT}
          </div>
          <div className="col-4">
            <strong>{t("responsable")}: </strong>
            {project?.responsableProyecto}
          </div>
          <div className="col-4">
            <strong>{t("ambito")}: </strong>
            {project?.tipoAmbito}
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <strong>{t("objetivo_general")}: </strong>
            <br />
            {project?.objetivoGeneral}
          </div>
          <br />
          <div className="col-12">
            <strong>{t("descripcion")}: </strong>
            <br />
            {project?.descripcion}
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-4">
            <strong>{t("fecha_ini")}: </strong>
            {project ? new Date(Date.parse(project?.fechaInicio)).toLocaleString('es', {
              year: "numeric",
              month: "2-digit",
              day: "numeric"
            }) : null}
          </div>
          <div className="col-4">
            <strong>{t("fecha_fin")}: </strong>
            {project ? new Date(Date.parse(project?.fechaFinalizacion)).toLocaleString('es', {
              year: "numeric",
              month: "2-digit",
              day: "numeric"
            }) : null}
          </div>
          <div className="col-4">
            <strong>{t("fondo")}: </strong> {project?.fondo}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link className="btn btn-success" to={`https://apps.iica.int/dashboardproyectos/programas/Detalle?CRON=${project?.cronoICT}&SCRON=${project?.subcronoICT}`} target="_blank">
          {t("ficha_completa")}
        </Link>
        <Button variant="secondary" onClick={hide}>
          {t("cerrar")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ProjectModal;
